import { Injectable } from "@angular/core";
import { NetworkService } from "../../common/network.service";

@Injectable()
export class PartnerService {
  constructor(private _networkService: NetworkService) { }

  getplanList() {
    return this._networkService.get("api/admins/partner", null, null, "bearer");
  }
  getplanListById(query) {
    return this._networkService.get("api/admins/partner?" + query, null, null, "bearer");
  }
  saveplan(body: any) {
    return this._networkService.post("api/admins/partner", body, null, "bearer");
  }
  Editplan(body: any) {
    return this._networkService.put("api/admins/partner", body, null, "bearer");
  }

  deleteplan(id: any) {
    return this._networkService.delete("api/admins/partner/" + id, null, "bearer")
  }
  getUserList(query:any) {

    return this._networkService.get("api/users/userList?"+query, null, null, "bearer");
  }
}
